import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/sass/overrides.sass';
import bg from './vuetify-locale/bg';

Vue.use(Vuetify)

const theme = {
  primary: '#1b61ac',
  secondary: '#184c7c',
  accent: '#ffde00',
  info: '#45aebb',
  success: "#63a14c"
}

export default new Vuetify({
  lang: { 
    locales: { bg },
    current: 'bg'
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
